"use client";

export const ru = {
  // Header
  "nav.services": "Услуги",
  "nav.about": "О нас",
  "nav.team": "Команда",
  "nav.gallery": "Галерея",
  "nav.reviews": "Отзывы",
  "nav.contacts": "Контакты",
  "nav.login": "Войти",
  "nav.dashboard": "Кабинет",

  // Hero
  "hero.badge": "Забота о ваших питомцах",
  "hero.title": "Ветеринарная клиника полного цикла",
  "hero.subtitle": "Современное оборудование, опытные врачи и индивидуальный подход к каждому пациенту",
  "hero.appointment": "Записаться на приём",
  "hero.services": "Наши услуги",
  "hero.stats.experience": "Лет опыта",
  "hero.stats.clients": "Довольных клиентов",
  "hero.stats.support": "Круглосуточно",

  // Services
  "services.title": "Наши услуги",
  "services.subtitle": "Полный спектр ветеринарных услуг для вашего питомца",
  "services.consultation": "Консультации",
  "services.consultation.desc": "Профессиональные консультации опытных ветеринаров",
  "services.surgery": "Хирургия",
  "services.surgery.desc": "Плановые и экстренные операции любой сложности",
  "services.diagnostics": "Диагностика",
  "services.diagnostics.desc": "Современное оборудование для точной диагностики",
  "services.vaccination": "Вакцинация",
  "services.vaccination.desc": "Полный комплекс прививок и профилактики",
  "services.hospitalization": "Стационар",
  "services.hospitalization.desc": "Круглосуточный уход и наблюдение",
  "services.grooming": "Груминг",
  "services.grooming.desc": "Профессиональный уход и гигиена",

  // About
  "about.title": "О нашей клинике",
  "about.subtitle": "Мы работаем с 2008 года и помогли тысячам животных",
  "about.mission": "Наша миссия",
  "about.mission.text": "Предоставлять качественную ветеринарную помощь, используя современные технологии и индивидуальный подход к каждому пациенту.",
  "about.values": "Наши ценности",
  "about.values.text": "Профессионализм, забота, честность и любовь к животным - основа нашей работы.",
  "about.equipment": "Оборудование",
  "about.equipment.text": "Современное диагностическое и хирургическое оборудование европейского качества.",

  // Team
  "team.title": "Наша команда",
  "team.subtitle": "Опытные специалисты с любовью к животным",
  "team.experience": "лет опыта",
  "team.position.head": "Главный врач",
  "team.position.surgeon": "Хирург",
  "team.position.therapist": "Терапевт",
  "team.position.nurse": "Старшая медсестра",

  // Gallery
  "gallery.title": "Наша клиника",
  "gallery.subtitle": "Современное оборудование и комфортная атмосфера",
  "gallery.reception": "Ресепшн",
  "gallery.surgery": "Операционная",
  "gallery.ward": "Палата",
  "gallery.diagnostics": "Диагностический кабинет",

  // Reviews
  "reviews.title": "Отзывы наших клиентов",
  "reviews.subtitle": "Что говорят о нас владельцы питомцев",

  // FAQ
  "faq.title": "Часто задаваемые вопросы",
  "faq.subtitle": "Ответы на популярные вопросы",
  "faq.q1": "Как записаться на приём?",
  "faq.a1": "Вы можете записаться через наш сайт, по телефону или через Telegram-бот.",
  "faq.q2": "Работаете ли вы круглосуточно?",
  "faq.a2": "Да, наша клиника работает 24/7. Экстренная помощь доступна в любое время.",
  "faq.q3": "Какие способы оплаты принимаете?",
  "faq.a3": "Мы принимаем наличные, карты и электронные платежи.",
  "faq.q4": "Нужна ли предварительная запись?",
  "faq.a4": "Для плановых приёмов рекомендуем записываться заранее. Экстренные случаи принимаем без записи.",

  // Contact
  "contact.title": "Контакты",
  "contact.subtitle": "Свяжитесь с нами удобным способом",
  "contact.address": "Адрес",
  "contact.phone": "Телефон",
  "contact.email": "Email",
  "contact.schedule": "График работы",
  "contact.schedule.text": "Круглосуточно, без выходных",
  
  // Contact Form
  "contacts.form.title": "Напишите нам",
  "contacts.form.subtitle": "Оставьте свои контакты и мы свяжемся с вами",
  "contacts.form.phone": "Телефон",
  "contacts.form.phoneHelper": "Формат: +998-XX-XXX-XX-XX",
  "contacts.form.phoneInvalid": "Пожалуйста, введите номер телефона в формате +998-XX-XXX-XX-XX",
  "contacts.form.fullName": "Имя Фамилия",
  "contacts.form.fullNamePlaceholder": "Иванов Иван",
  "contacts.form.firstName": "Имя",
  "contacts.form.firstNamePlaceholder": "Иван",
  "contacts.form.lastName": "Фамилия",
  "contacts.form.lastNamePlaceholder": "Иванов",
  "contacts.form.message": "Сообщение (обязательно)",
  "contacts.form.messagePlaceholder": "Напишите ваше сообщение или вопрос...",
  "contacts.form.messageHelper": "Минимум 5 символов, максимум 2000",
  "contacts.form.submit": "Отправить",
  "contacts.form.sending": "Отправка...",
  "contacts.form.success": "Спасибо!",
  "contacts.form.successDesc": "Мы свяжемся с вами в ближайшее время",
  "contacts.form.error": "Ошибка",
  "contacts.form.invalidPhone": "Неверный формат телефона. Используйте формат +998XXXXXXXXX",
  "contacts.form.invalidName": "Имя должно содержать только буквы, пробелы и дефисы (2-64 символа)",

  // Footer
  "footer.about": "О клинике",
  "footer.about.text": "Ветеринарная клиника с современным оборудованием и опытными специалистами. Работаем для здоровья ваших питомцев.",
  "footer.links": "Быстрые ссылки",
  "footer.contacts": "Контакты",
  "footer.rights": "Все права защищены",

  // Auth
  "auth.title": "ELVET",
  "auth.subtitle": "Вход в систему управления",
  "auth.login": "Вход",
  "auth.phoneLogin": "Вход по телефону",
  "auth.registration": "Регистрация",
  "auth.loginByMethod": "Выберите способ входа в систему",
  "auth.phone": "Телефон",
  "auth.phonePlaceholder": "+998 90 123 45 67",
  "auth.phoneHelper": "Формат: +998 XX XXX XX XX",
  "auth.invalidPhone": "Неверный формат телефона",
  "auth.phoneNotFound": "Телефон не найден в системе",
  "auth.password": "Пароль",
  "auth.passwordPlaceholder": "••••••••",
  "auth.forgotPassword": "Забыли пароль?",
  "auth.loginButton": "Войти",
  "auth.registerViaTelegram": "Зарегистрироваться через Telegram",
  "auth.telegramRegisterDesc": "Быстрая и безопасная регистрация через Telegram бот",
  "auth.telegramNote": "После регистрации в боте, вы автоматически будете авторизованы на сайте",
  "auth.error": "Ошибка",
  "auth.loginError": "Ошибка входа",
  "auth.loginSuccess": "Успешный вход",
  "auth.welcome": "Добро пожаловать!",
  "auth.passwordChangeRequired": "Требуется смена пароля",
  "auth.setPermPassword": "Пожалуйста, установите постоянный пароль",
  "auth.visitClinic": "Посетите нашу\nвет клинику",
  "auth.professionalCare": "Профессиональная забота\nо ваших питомцах",
  "auth.contactTelegram": "Связаться через Telegram",
  "auth.backToHome": "Вернуться на главную",

  // Dashboard
  "dashboard.welcome": "Добро пожаловать",
  "dashboard.client": "Личный кабинет клиента",
  "dashboard.moderator": "Панель модератора",
  "dashboard.doctor": "Панель врача",
  "dashboard.admin": "Панель администратора",
  "dashboard.nurse": "Панель медсестры",
  "dashboard.logout": "Выйти",
  "dashboard.myPets": "Мои питомцы",
  "dashboard.medicalHistory": "История мед. карт",
  "dashboard.medicalHistoryShort": "История",
  "dashboard.medicalCards": "Медицинские карты",
  "dashboard.appointments": "Записи на приём",
  "dashboard.profile": "Профиль",

  // Doctor page
  "doctor.newCard.title": "Новая медкарта",
  "doctor.newCard.subtitle": "Заполните информацию о питомце, диагноз, анализы, услуги и препараты",
  "doctor.sections.petAndExam": "Данные питомца и осмотра",
  // Tabs (Doctor) - для обратной совместимости
  "doctor.tabs.clients": "Клиенты",
  "doctor.tabs.services": "Услуги",
  "doctor.tabs.medicines": "Препараты",
  "doctor.tabs.history": "История карт",
  "doctor.tabs.rooms": "Палаты",
  // Навигация сайдбара доктора
  "doctor.sidebar.navigation": "Навигация",
  "doctor.sidebar.main": "Главная",
  "doctor.sidebar.clients": "Клиенты",
  "doctor.sidebar.services": "Услуги",
  "doctor.sidebar.medicines": "Препараты",
  "doctor.sidebar.history": "История карт",
  "doctor.sidebar.rooms": "Палаты",
  "doctor.sidebar.salary": "История зарплаты",
  "doctor.sidebar.collapse": "Свернуть сайдбар",
  "doctor.sidebar.expand": "Развернуть сайдбар",
  "doctor.sidebar.hint": "Используйте сайдбар для навигации между разделами",
  "doctor.pet.selectLabel": "Питомец клиента",
  "doctor.pet.selectPlaceholder": "Выберите питомца",
  "doctor.pet.loading": "Загрузка питомцев…",
  "doctor.pet.loadError": "Не удалось загрузить питомцев",
  "doctor.pet.none": "Нет питомцев",
  "doctor.pet.create": "Создать питомца",
  "doctor.pet.createHelp": "Создайте карточку питомца для клиента",
  "doctor.pet.addNew": "Добавить нового питомца",
  "doctor.pet.form.title": "Новый питомец",
  "doctor.pet.form.subtitle": "Создайте карточку питомца для клиента",
  "doctor.pet.name": "Имя",
  "doctor.pet.namePlaceholder": "Барсик",
  "doctor.pet.species": "Вид",
  "doctor.pet.speciesPlaceholder": "Выберите вид",
  "doctor.pet.species.dog": "Собака",
  "doctor.pet.species.cat": "Кошка",
  "doctor.pet.species.bird": "Птица",
  "doctor.pet.species.reptile": "Рептилия",
  "doctor.pet.species.other": "Другое",
  "doctor.pet.gender": "Пол",
  "doctor.pet.genderPlaceholder": "Выберите пол",
  "doctor.pet.gender.male": "Самец",
  "doctor.pet.gender.female": "Самка",
  "doctor.pet.breed": "Порода",
  "doctor.pet.breedPlaceholder": "Британская",
  "doctor.pet.birthDate": "Дата рождения",
  "doctor.pet.color": "Окрас",
  "doctor.pet.colorPlaceholder": "Рыжий",
  "doctor.pet.weight": "Вес (кг)",
  "doctor.pet.weightPlaceholder": "4.5",
  "doctor.pet.description": "Описание",
  "doctor.pet.descriptionPlaceholder": "Хронических заболеваний нет...",

  "doctor.vitals.weight": "Вес",
  "doctor.vitals.weightPlaceholder": "4.2",
  "doctor.vitals.temperature": "Температура",
  "doctor.vitals.temperaturePlaceholder": "38.5",
  "doctor.vitals.bloodPressure": "Давление (мм рт. ст.)",
  "doctor.vitals.bloodPressurePlaceholder": "120",
  "doctor.vitals.heartRate": "ЧСС (уд/мин)",
  "doctor.vitals.heartRatePlaceholder": "90",
  "doctor.vitals.respiratoryRate": "ЧДД (вдохов/мин)",
  "doctor.vitals.respiratoryRatePlaceholder": "20",
  "doctor.vitals.mucous": "Слизистые",
  "doctor.vitals.mucousPlaceholder": "розовые, влажные",
  "doctor.vitals.chest": "Состояние грудной клетки",
  "doctor.vitals.chestPlaceholder": "без хрипов, перкуссия чистая",
  "doctor.vitals.anamnez": "Анамнез (жалобы и симптомы)",
  "doctor.vitals.anamnezPlaceholder": "Текущие жалобы, история болезни, симптомы...",
  "doctor.vitals.naznacheniya": "Назначения",
  "doctor.vitals.naznacheniyaPlaceholder": "План лечения, медикаменты, рекомендации по уходу...",
  "doctor.vitals.statusSection": "Статус пациента (Витальные показатели)",
  "doctor.vitals.generalCondition": "Статус пациента",
  "doctor.vitals.generalConditionPlaceholder": "Вес: 4.2 кг, Температура: 38.5°C, АД: 120/80, ЧСС: 90 уд/мин, ЧДД: 20 вдохов/мин, Слизистые: розовые влажные...",
  "doctor.revisitDate": "Дата повторного визита",
  "client.medicalCards.naznacheniya": "Назначения",
  "client.medicalCards.naznacheniya.empty": "—",

  "doctor.services.title": "Услуги",
  "doctor.services.subtitle": "Выберите услуги, укажите количество и описание",
  "doctor.medicines.title": "Препараты",
  "doctor.medicines.subtitle": "Выберите препараты, укажите количество и дозировку",
  "doctor.feeds.title": "Корма",
  "doctor.feeds.subtitle": "Выберите корма и укажите количество",
  "doctor.search.servicePlaceholder": "Поиск услуги...",
  "doctor.search.medicinePlaceholder": "Поиск препарата...",
  "doctor.search.feedPlaceholder": "Поиск корма...",
  "doctor.price": "{{price}} сум",
  "doctor.inStock": "Доступно: {{stock}}",
  "doctor.qtyPlaceholder": "Кол-во",
  "doctor.qtyZeroPlaceholder": "0",
  "doctor.serviceDescPlaceholder": "Описание выполненной услуги",
  "doctor.dosagePlaceholder": "Дозировка",
  "doctor.clear": "Очистить",

  "doctor.stationary.title": "Стационар",
  "doctor.stationary.subtitle": "При необходимости оформите стационар",
  "doctor.stationary.checkbox": "Оформить стационар",
  "doctor.stationary.period": "Период стационара",
  "doctor.stationary.selectPeriod": "Выберите период",
  "doctor.stationary.noPeriods": "Периоды стационара не настроены. Обратитесь к администратору.",
  "doctor.stationary.loadError": "Не удалось загрузить периоды стационара",
  "doctor.stationary.room": "Палата",
  "doctor.stationary.selectRoom": "Выбрать палату",
  "doctor.stationary.roomSelected": "Выбрана: {{room}}",
  "doctor.stationary.roomIdNote": "Будет передан ID палаты: {{id}}",
  "doctor.stationary.startDate": "Дата поступления",
  "doctor.stationary.endDate": "Дата выписки",

  "doctor.freeRooms.title": "Свободные палаты",
  "doctor.freeRooms.subtitle": "Выберите палату для размещения пациента",
  "doctor.freeRooms.loading": "Загрузка свободных палат…",
  "doctor.freeRooms.id": "ID: {{id}}",
  "doctor.freeRooms.pricePerDay": "Цена/день: {{price}}",
  "doctor.freeRooms.select": "Выбрать",
  "doctor.freeRooms.empty": "Свободных палат не найдено",

  "doctor.schedule.title": "График стационара",
  "doctor.schedule.subtitle": "Укажите период и добавьте задачи для медсестры",
  "doctor.schedule.datetime": "Дата и время визита",
  "doctor.schedule.hint": "Укажите, когда пациент должен вернуться или начать стационар.",
  "doctor.schedule.loading": "Загрузка данных графика…",
  "doctor.schedule.save": "Сохранить график",
  "doctor.schedule.cardMissing": "Не выбран номер медкарты",
  "doctor.schedule.datetimeRequired": "Укажите дату и время графика",
  "doctor.schedule.invalidDate": "Некорректная дата или время",
  "doctor.schedule.createError": "Не удалось создать график",
  "doctor.schedule.saveSuccess": "График сохранён",
  "doctor.schedule.saveErrorTitle": "Ошибка сохранения графика",
  "doctor.schedule.saveErrorDescription": "Произошла ошибка при сохранении графика",
  "doctor.schedule.nursesLoadError": "Не удалось загрузить медсестёр",
  "doctor.schedule.servicesLoadError": "Не удалось загрузить услуги",

  // Doctor card creation flow
  "doctor.create.validation.selectClient": "Выберите клиента",
  "doctor.create.validation.selectPet": "Выберите питомца",
  "doctor.create.validation.selectNurse": "Выберите ответственную медсестру",
  "doctor.create.validation.diagnosis": "Укажите диагноз",
  "doctor.create.validation.requiredFieldsTitle": "Обязательные поля не заполнены",
  "doctor.create.validation.selectItems": "Добавьте хотя бы одну услугу, препарат или корм",
  "doctor.create.validation.medicineDosage": "Укажите дозировку для каждого выбранного препарата",
  "doctor.create.determineDoctorError": "Не удалось определить профиль врача",
  "doctor.create.tryLater": "Повторите позже или обратитесь к администратору",
  "doctor.create.createErrorTitle": "Не удалось создать медкарту",
  "doctor.create.serverError": "Ошибка сервера",
  "doctor.create.idMissingTitle": "Не найден ID медкарты",
  "doctor.create.idMissingDescription": "Сервер не вернул идентификатор медкарты",
  "doctor.create.successTitle": "Медкарта создана",
  "doctor.create.successDescription": "Карта №{{id}} успешно сохранена",
  "doctor.create.nursesLoadError": "Не удалось загрузить медсестёр",
  "doctor.create.assignedNurseLabel": "Ответственная медсестра",
  "doctor.create.assignedNursePlaceholder": "Выберите медсестру",
  "doctor.create.noNurses": "Нет доступных медсестёр",
  "doctor.create.pet.noClient": "Выберите клиента перед созданием питомца",
  "doctor.create.pet.nameRequired": "Укажите имя питомца",
  "doctor.create.pet.speciesRequired": "Выберите вид питомца",
  "doctor.create.pet.genderRequired": "Выберите пол питомца",
  "doctor.create.pet.successTitle": "Питомец создан",
  "doctor.create.pet.successDescription": "{{name}} добавлен клиенту",
  "doctor.create.pet.errorTitle": "Не удалось создать питомца",
  "doctor.create.pet.errorUnknown": "Неизвестная ошибка при создании питомца",

  "doctor.edit.title": "Редактировать медкарту",
  "doctor.edit.subtitle": "Доступно редактирование только до оплаты. Изменения сохраняются частично.",
  "doctor.edit.stationarySubtitle": "Выберите период стационара, настроенный администратором",
  "doctor.edit.stationaryRequiredTitle": "Не выбран период стационара",
  "doctor.edit.stationaryRequiredDescription": "Перед сохранением выберите период стационара.",

  // Doctor salary history
  "doctor.salary.today": "Доход за сегодня",
  "doctor.salary.weekly": "Доход за неделю",
  "doctor.salary.monthly": "Доход за месяц",
  "doctor.salary.dropdown.weekly": "Неделя",
  "doctor.salary.dropdown.monthly": "Месяц",
  "doctor.salary.total": "Итого",
  "doctor.salary.events": "События",
  "doctor.salary.empty": "Нет операций дохода",
  "doctor.salary.loading": "Загрузка истории дохода…",
  "doctor.salary.error": "Ошибка загрузки",
  "doctor.salary.errorDesc": "Не удалось получить историю дохода",
  "doctor.salary.source.SERVICE_USAGE": "Использование услуги",
  "doctor.salary.source.OTHER": "Другое",
  
  // Doctor schedule task builder
  "doctor.schedule.addTaskTitle": "Добавить задачу",
  "doctor.schedule.addTaskSubtitle": "Кто, когда и что делает",
  "doctor.schedule.task.validationTitle": "Проверьте данные задачи",
  "doctor.schedule.task.validationDescription": "Заполните название, описание, сроки, медсестру и услугу",
  "doctor.schedule.task.validationExtended": "Задача должна содержать название, описание, время начала/окончания, медсестру и услугу",
  "doctor.schedule.task.nameLabel": "Название задачи",
  "doctor.schedule.task.namePlaceholder": "Инъекция, кормление...",
  "doctor.schedule.task.startDateLabel": "Начало",
  "doctor.schedule.task.startTimeLabel": "Время начала",
  "doctor.schedule.task.deadlineDateLabel": "Срок до",
  "doctor.schedule.task.deadlineTimeLabel": "Время срока",
  "doctor.schedule.task.nurseLabel": "Медсестра",
  "doctor.schedule.task.nurseSelectPlaceholder": "Выберите медсестру",
  "doctor.schedule.task.nurseSelectLoading": "Загрузка…",
  "doctor.schedule.task.noUsers": "Нет доступных пользователей",
  "doctor.schedule.task.serviceLabel": "Услуга",
  "doctor.schedule.task.serviceSelectPlaceholder": "Выберите услугу",
  "doctor.schedule.task.serviceSelectLoading": "Загрузка…",
  "doctor.schedule.task.noServices": "Нет услуг",
  "doctor.schedule.task.descriptionLabel": "Описание",
  "doctor.schedule.task.descriptionPlaceholder": "Инъекция антибиотика, уход...",
  "doctor.schedule.task.addButton": "Добавить",
  "doctor.schedule.task.createError": "Не удалось создать задачу",
  "doctor.schedule.tasksTitle": "Задачи",
  "doctor.schedule.tasksSubtitle": "План на период",
  "doctor.schedule.tasksEmpty": "Задач нет",
  "doctor.schedule.task.untitled": "Без названия",
  "doctor.schedule.task.persistedBadge": "сохранена",
  "doctor.schedule.task.startPrefix": "Старт:",
  "doctor.schedule.task.deadlinePrefix": "Срок:",
  "doctor.schedule.task.deleteButton": "Удалить",

  // Generic fetch helper
  "doctor.fetch.errorTitle": "Ошибка загрузки данных",
  "doctor.fetch.errorDescription": "Не удалось загрузить {{resource}}",

  // Common additions
  "common.optional": "необязательно",
  "common.cancel": "Отменить",
  "common.save": "Сохранить",
  "common.create": "Создать",
  "common.creating": "Создание…",
  "common.saving": "Сохранение…",
  "common.loading": "Загрузка…",
  "common.empty": "Нет данных",
  "common.view": "Просмотр",
  "common.close": "Закрыть",
  "common.confirmPayment": "Принять оплату",
  "common.confirmed": "Подтверждено",
  "common.error": "Ошибка",
  "common.nothingFound": "Ничего не найдено",
  
  // Tabs (Nurse)
  "nurse.tabs.procedures": "Процедуры",
  "nurse.tabs.medicines": "Лекарства",
  "nurse.tabs.schedule": "Расписание",

  // Tabs (Moderator)
  "moderator.tabs.billing": "Медицинские карты",
  "moderator.tabs.visits": "Визиты",
  "moderator.tabs.password": "Пароль клиента",
  "moderator.tabs.requests": "Запросы",
  
  // Moderator dashboard KPI
  "moderator.kpi.medicinesAvailable": "Доступных лекарств",
  "moderator.kpi.servicesCount": "Услуг всего",
  "moderator.kpi.visitsCount": "Визитов всего",

  // Moderator medical cards section
  "moderator.medicalCards.title": "Медицинские карты",
  "moderator.medicalCards.subtitle": "Карты, ожидающие оплаты",
  "moderator.medicalCards.refresh": "Обновить список",

  // Moderator visits section
  "moderator.visits.create.title": "Создать визит",
  "moderator.visits.create.subtitle": "Выберите клиента, врача и при необходимости питомца",
  "moderator.visits.history.title": "История визитов",
  "moderator.visits.history.subtitle": "Список визитов",
  "moderator.visits.refresh": "Обновить",

  // Moderator requests section
  "moderator.requests.title": "Запросы клиентов",
  "moderator.requests.subtitle": "Обращения с сайта",
  "moderator.requests.refresh": "Обновить",

  // Moderator card modal
  "moderator.card.modal.title": "Карта #{{id}}",
  "moderator.card.modal.subtitle": "Просмотр и подтверждение оплаты",
  "moderator.card.modal.client": "Клиент",
  "moderator.card.modal.pet": "Питомец",
  "moderator.card.modal.status": "Статус",
  "moderator.card.modal.total": "Итого",
  
  // Doctor clients tab & client profile
  "doctor.clients.title": "Клиенты",
  "doctor.clients.subtitle": "Список клиентов и телефоны",
  "doctor.profile.notFoundTitle": "Не найден профиль врача",
  "doctor.profile.notFoundDescription": "Обратитесь к администратору",
  "doctor.clients.searchPlaceholder": "Поиск клиента по имени или телефону...",
  "doctor.clients.loading": "Загрузка клиентов…",
  "doctor.clients.profileButton": "Профиль",
  "doctor.clients.nothing": "Ничего не найдено",
  "doctor.clients.total": "Всего: {{count}}",
  "doctor.clientProfile.title": "Профиль клиента",
  "doctor.clientProfile.subtitle": "Карточка клиента и его медкарты",
  "doctor.clientProfile.phone": "Телефон:",
  "doctor.clientProfile.address": "Адрес:",
  "doctor.clientProfile.description": "Описание:",
  "doctor.clientProfile.close": "Закрыть",
  "doctor.clientProfile.createCard": "Создать медкарту",
  "doctor.clientCards.title": "Медкарты клиента",
  "doctor.clientCards.subtitle": "Последние записи",
  "doctor.clientCards.loadError": "Не удалось загрузить медкарты",
  "doctor.clientCards.status.open": "Открыта",
  "doctor.clientCards.status.waiting": "Ожидает оплаты",
  "doctor.clientCards.status.closed": "Закрыта",
  "doctor.clientCards.edit": "Изменить",
  "doctor.clientCards.empty": "Карточек нет",

  // Doctor services list tab
  "doctor.servicesList.title": "Доступные услуги",
  "doctor.servicesList.subtitle": "Каталог услуг",
  "doctor.servicesList.searchPlaceholder": "Поиск услуги...",
  "doctor.servicesList.loading": "Загрузка услуг…",
  "doctor.servicesList.empty": "Ничего не найдено",
  "doctor.servicesList.total": "Всего: {{count}}",

  // Doctor medicines list tab
  "doctor.medicinesList.title": "Доступные препараты",
  "doctor.medicinesList.subtitle": "Остатки на складе",
  "doctor.medicinesList.searchPlaceholder": "Поиск препарата...",
  "doctor.medicinesList.loading": "Загрузка препаратов…",
  "doctor.medicinesList.empty": "Ничего не найдено",
  "doctor.medicinesList.stockPrefix": "Остаток: {{stock}}",
  "doctor.medicinesList.unitDefault": "шт",
  "doctor.medicinesList.total": "Всего: {{count}}",

  // Doctor history tab
  "doctor.history.title": "История карт (мои)",
  "doctor.history.subtitle": "Последние созданные/открытые карты",
  "doctor.history.loading": "Загрузка истории…",
  "doctor.history.status.open": "Открыта",
  "doctor.history.status.waiting": "Ожидает оплаты",
  "doctor.history.status.closed": "Закрыта",
  "doctor.history.edit": "Изменить",
  "doctor.history.viewDisabled": "Просмотр недоступен",
  "doctor.history.empty": "Нет данных",
  "doctor.history.total": "Всего: {{count}}",

  // Doctor rooms tab
  "doctor.rooms.title": "Палаты",
  "doctor.rooms.subtitle": "Доступные стационарные комнаты",
  "doctor.rooms.loading": "Загрузка палат…",
  "doctor.rooms.roomLabel": "Палата",
  "doctor.rooms.free": "Свободна",
  "doctor.rooms.busy": "Занята",
  "doctor.rooms.pricePerDayPrefix": "Цена/день:",
  "doctor.rooms.noDescription": "Нет описания",
  "doctor.rooms.empty": "Нет данных",
  "doctor.rooms.total": "Всего: {{count}}",

  // Fallback labels
  "doctor.pet.fallback": "Питомец #{{id}}",
  "doctor.room.fallback": "Палата #{{id}}",

  // Pagination/common nav
  "common.prev": "Назад",
  "common.next": "Вперёд",
  "doctor.currency.som": "сум",
  
  // Doctor hero & banner
  "doctor.hero.subtitle": "Панель управления врача",
  "doctor.hero.fallbackRole": "Доктор",
  "doctor.banner.edit": "Изменить",
  "doctor.banner.loading": "Загрузка…",
  
  // Doctor stats boxes
  "doctor.stats.services.title": "Услуги",
  "doctor.stats.services.subtitle": "Доступно (типов)",
  "doctor.stats.medicines.title": "Препараты",
  "doctor.stats.medicines.subtitle": "На складе (видов)",
  "doctor.stats.feeds.title": "Корма",
  "doctor.stats.feeds.subtitle": "В наличии (типов)",
  
  // Common navigation
  "common.goHome": "На главную",
  "common.delete": "Удалить",
  "common.search": "Поиск",

  // Edit card modal - services
  "doctor.edit.services.title": "Услуги в счёте",
  "doctor.edit.services.subtitle": "Измените количество, описание или добавьте новые услуги",
  "doctor.edit.services.fallback": "Услуга #{{id}}",
  "doctor.edit.services.descriptionPlaceholder": "Описание",
  "doctor.edit.services.delete": "Удалить",
  "doctor.edit.services.empty": "Нет услуг",
  "doctor.edit.services.add": "Добавить услугу",
  "doctor.edit.services.search": "Поиск",

  // Edit card modal - medicines
  "doctor.edit.medicines.title": "Препараты в счёте",
  "doctor.edit.medicines.subtitle": "Измените количество/дозировку или добавьте новые препараты",
  "doctor.edit.medicines.fallback": "Препарат #{{id}}",
  "doctor.edit.medicines.dosagePlaceholder": "Дозировка",
  "doctor.edit.medicines.delete": "Удалить",
  "doctor.edit.medicines.empty": "Нет препаратов",
  "doctor.edit.medicines.add": "Добавить препарат",
  "doctor.edit.medicines.search": "Поиск",

  // Edit card modal - feeds
  "doctor.edit.feeds.title": "Корма в счёте",
  "doctor.edit.feeds.subtitle": "Измените количество или добавьте новые корма",
  "doctor.edit.feeds.fallback": "Корм #{{id}}",
  "doctor.edit.feeds.selectPlaceholder": "Выберите корм",
  "doctor.edit.feeds.delete": "Удалить",
  "doctor.edit.feeds.empty": "Нет кормов",
  "doctor.edit.feeds.add": "Добавить корм",
  "doctor.edit.feeds.search": "Поиск",
  
  // Client dashboard - Appointments
  "client.appointments.title": "Мои записи",
  "client.appointments.create": "Записаться на приём",
  "client.appointments.status.waiting": "Ожидает",
  "client.appointments.status.confirmed": "Подтверждена",
  "client.appointments.status.canceled": "Отменена",
  "client.appointments.cancel.confirmTitle": "Отменить запись?",
  "client.appointments.cancel.confirmDescription": "Вы уверены, что хотите отменить эту запись?",
  "client.appointments.toast.createSuccess": "Запись создана",
  "client.appointments.toast.createError": "Не удалось создать запись",
  "client.appointments.toast.cancelSuccess": "Запись отменена",
  "client.appointments.toast.cancelError": "Не удалось отменить запись",
  "client.appointments.dialogTitle": "Запись на приём",
  "client.appointments.dialogDescription": "Выберите дату, время и врача",
  "client.appointments.pet.label": "Питомец",
  "client.appointments.pet.placeholder": "Выберите питомца",
  "client.appointments.doctor.label": "Врач",
  "client.appointments.doctor.placeholder": "Выберите врача",
  "client.appointments.date.label": "Дата *",
  "client.appointments.time.label": "Время *",
  "client.appointments.service.label": "Тип услуги",
  "client.appointments.service.placeholder": "Консультация, вакцинация...",
  "client.appointments.notes.label": "Примечания",
  "client.appointments.notes.placeholder": "Опишите проблему...",
  "client.appointments.submit": "Записаться",
  "client.appointments.submitting": "Запись...",
  "client.appointments.manageDescription": "Управление записями на приём",
  "client.appointments.empty": "У вас нет предстоящих записей",
  "client.appointments.petPrefix": "Питомец:",
  "client.appointments.doctorPrefix": "Врач:",
  "client.appointments.status.completed": "Завершена",
  "client.appointments.status.cancelled": "Отменена",

  // Client dashboard - Password dialog
  "client.password.dialogTitle": "Установите постоянный пароль",
  "client.password.passwordMismatch": "Пароли не совпадают",
  "client.password.passwordTooShort": "Пароль должен содержать минимум 6 символов",
  "client.password.saveSuccess": "Пароль сохранён",
  "client.password.saveError": "Не удалось сохранить пароль",

  // Client dashboard - Medical cards viewer
  "client.medicalCards.title": "Медицинские карты",
  "client.medicalCards.historyTitle": "История посещений",
  "client.medicalCards.status.pending": "Ожидающие",
  "client.medicalCards.status.paid": "Оплаченные",
  "client.medicalCards.status.partlyPaid": "Частично оплачено",
  "client.medicalCards.stationaryBadge": "Стационар",
  "client.medicalCards.services": "Услуги",
  "client.medicalCards.medicines": "Медикаменты",
  "client.medicalCards.services.empty": "Нет услуг",
  "client.medicalCards.medicines.empty": "Нет медикаментов",
  "client.medicalCards.stationaryRoom.title": "Стационарная палата",
  "client.medicalCards.stationaryRoom.payment": "Оплата за стационар",

  // Client dashboard - Pets manager
  "client.pets.title": "Мои питомцы",
  "client.pets.addPet": "Добавить питомца",
  "client.pets.updatePet": "Обновить питомца",
  "client.pets.empty": "Нет зарегистрированных питомцев",
  "client.pets.namePlaceholder": "Барсик",
  "client.pets.breedPlaceholder": "Лабрадор",
  "client.pets.toast.createSuccess": "Питомец добавлен",
  "client.pets.toast.updateSuccess": "Питомец обновлён",
  "client.pets.toast.deleteSuccess": "Питомец удалён",
  "client.pets.toast.errorGeneric": "Ошибка операции",

  // Client dashboard - Profile editor
  "client.profile.title": "Мой профиль",
  "client.profile.subtitle": "Личная информация",
  "client.profile.firstName": "Имя",
  "client.profile.lastName": "Фамилия",
  "client.profile.photo": "Фото профиля",
  "client.profile.address": "Адрес",
  "client.profile.phonePrimary": "Основной телефон",
  "client.profile.phoneSecondary": "Дополнительный телефон",
  "client.profile.phoneInvalid": "Неверный формат телефона",
  "client.profile.phonesMustDiffer": "Номера телефонов должны отличаться",
  "client.profile.error.duplicatePhone": "Дубликат номера телефона",
  "client.profile.error.phoneAlreadyInUse": "Этот номер телефона ({{phone}}) уже используется другим аккаунтом",
  "client.profile.edit": "Редактировать профиль",
  "client.profile.toast.updateSuccess": "Профиль обновлён",
  "client.profile.toast.photoUpdateSuccess": "Фото обновлено",
  "client.profile.toast.updateError": "Не удалось обновить профиль",
  "client.profile.subtitleExtended": "Личная информация и настройки аккаунта",
  "client.profile.extraPhone1": "Доп. номер 1",
  "client.profile.extraPhone2": "Доп. номер 2",
  "client.profile.photo.change": "Заменить",
  "client.profile.photo.uploading": "Загрузка...",
  "client.profile.saving": "Сохранение...",
  "client.profile.phone.helper": "Формат: +998 XX XXX XX XX",
  
  // Client pets manager extended
  "client.pets.dialog.description": "Заполните информацию о вашем питомце",
  "client.pets.addNew": "Добавить нового питомца",
  "client.pets.update": "Обновить питомца",
  "client.pets.name.label": "Кличка *",
  "client.pets.species.label": "Вид животного *",
  "client.pets.gender.label": "Пол *",
  "client.pets.breed.label": "Порода",
  "client.pets.birthDate.label": "Дата рождения",
  "client.pets.color.label": "Окрас",
  "client.pets.weight.label": "Вес (кг)",
  "client.pets.notes.label": "Заметки",
  "client.pets.photo.label": "Фото питомца",
  "client.pets.invalidBirthDateTitle": "Некорректная дата рождения",
  "client.pets.invalidBirthDateDescription": "Дата рождения не может быть в будущем",
  "client.pets.toast.createDescription": "{{name}} успешно зарегистрирован",
  "client.pets.toast.deleteDescription": "{{name}} удален из списка",
  "client.pets.deleteConfirm": "Удалить питомца {{name}}?",
  "client.pets.age.label": "Возраст",
  "client.pets.age.yearsSuffix": "лет",
  "client.pets.notes.heading": "Заметки:",
  "client.pets.emptyHelp": "Добавьте своего первого питомца, чтобы начать отслеживать его здоровье",
  "client.pets.creating": "Добавление...",
  "client.pets.saving": "Сохранение...",
  "client.pets.reptile": "Рептилия",
  
  // Client medical cards extended
  "client.medicalCards.subtitle": "История посещений и лечения ваших питомцев",
  "client.medicalCards.empty": "Медицинские карты отсутствуют",
  "client.medicalCards.column.pending": "Ожидающие",
  "client.medicalCards.column.paid": "Оплаченные",
  "client.medicalCards.petFallback": "Питомец",
  "client.medicalCards.detailsToggle": "Детали (услуги и рецепты)",
  "client.medicalCards.doctor.loading": "Доктор: загрузка...",
  "client.medicalCards.doctor.unknown": "Доктор: неизвестен",
  "client.medicalCards.doctor.prefix": "Dr.",
  "client.medicalCards.assignedNurse": "Ответственная медсестра",
  "client.medicalCards.assignedNurse.unknown": "Не назначена",
  
  // Nurse medical card view
  "nurse.medicalCards.assignedNurse": "Ответственная медсестра",
  
  // Client dashboard banner/nav helpers
  "client.hero.fallbackRole": "Клиент",
  "client.dashboard.welcomeSubtitle": "Управляйте здоровьем ваших питомцев в одном месте",
  "client.logout.goodbye": "До свидания!",
  "client.revisit.reminder": "Завтра вам нужно посетить ELVET — врач назначил повторный приём для {{petName}} на {{date}}.",
  "client.revisit.dismiss": "Закрыть",

  // Common extra
  "common.goodbye": "До свидания!",

  // Nurse banner & profile
  "nurse.banner.subtitle": "Забота о пациентах",
  "nurse.banner.dailySalaryLabel": "Текущая дневная ставка:",
  "nurse.banner.defaultName": "Медсестра",
  "nurse.banner.changeImage": "Изменить",
  "nurse.banner.uploading": "Загрузка…",
  "nurse.profileNotFound.title": "Профиль медсестры не найден",
  "nurse.profileNotFound.description": "Обратитесь к администратору для доступа",
  "nurse.profileNotFound.inlineWarning": "Не удалось определить ваш профиль медсестры. Обратитесь к администратору, чтобы продолжить работу с задачами.",

  // Nurse sidebar navigation
  "nurse.sidebar.navigation": "Навигация",
  "nurse.sidebar.main": "Главная",
  "nurse.sidebar.procedures": "Процедуры",
  "nurse.sidebar.medicalCards": "Медицинские карты",
  "nurse.sidebar.nurseCare": "Уход медсестры",
  "nurse.sidebar.medicines": "Лекарства",
  "nurse.sidebar.schedule": "Расписание",
  "nurse.sidebar.salary": "История зарплаты",
  "nurse.sidebar.collapse": "Свернуть боковую панель",
  "nurse.sidebar.expand": "Развернуть боковую панель",
  "nurse.sidebar.hint": "Используйте боковую панель для навигации",

  // Nurse metrics boxes
  "nurse.metrics.title": "Рабочие показатели",
  "nurse.metrics.refresh": "Обновить",
  "nurse.metrics.salary.label": "Дневная ставка",
  "nurse.metrics.salary.subtitle": "Обновляется после выполнения задач",
  "nurse.metrics.todo.label": "Задачи в работе",
  "nurse.metrics.todo.subtitle": "Ожидают выполнения",
  "nurse.metrics.doneToday.label": "Выполнено сегодня",
  "nurse.metrics.doneToday.subtitle": "Завершено за сегодня",
  "nurse.metrics.done.label": "Всего завершено",
  "nurse.metrics.done.subtitle": "История выполненных задач",
  "nurse.metrics.medicines.label": "Лекарства на складе",
  "nurse.metrics.medicines.subtitle": "Доступных позиций",
  "nurse.metrics.pets.label": "Питомцев в клинике",
  "nurse.metrics.pets.subtitle": "Всего зарегистрировано",
  "nurse.metrics.roomsTaken.label": "Занятые места",
  "nurse.metrics.roomsTaken.subtitle": "Занято мест в палатах",

  // Nurse medicines tab
  "nurse.medicines.title": "Склад лекарств",
  "nurse.medicines.description": "Все лекарства в базе данных с текущими остатками",
  "nurse.medicines.loading": "Обновляем данные склада...",
  "nurse.medicines.empty": "Список лекарств пуст",
  "nurse.medicines.total": "Всего: {{count}}",
  "nurse.medicines.searchPlaceholder": "Поиск лекарств по названию или категории...",
  "nurse.medicines.noSearchResults": "Лекарства не найдены по вашему запросу",
  "nurse.medicines.clearSearch": "Очистить поиск",
  "nurse.medicines.searchResults": "Показано {{count}} из {{total}} лекарств",
  "nurse.medicines.table.name": "Название",
  "nurse.medicines.table.category": "Категория",
  "nurse.medicines.table.stock": "Остаток",
  "nurse.medicines.table.updated": "Обновлено",

  // Nurse schedule tab
  "nurse.schedule.title": "Расписание процедур",
  "nurse.schedule.empty": "Задачи с датой пока не найдены",
  "nurse.schedule.tasks_one": "{{count}} задача",
  "nurse.schedule.tasks_few": "{{count}} задачи",
  "nurse.schedule.tasks_many": "{{count}} задач",
  "nurse.schedule.tasks_other": "{{count}} задач",
  "nurse.task.untitled": "Без названия",

  // Nurse tasks component
  "nurse.tasks.title": "Задачи по уходу за пациентами",
  "nurse.tasks.description": "Рабочий список процедур для медсестры",
  "nurse.tasks.refresh": "Обновить",
  "nurse.tasks.loading": "Загружаем задания...",
  "nurse.tasks.profileMissing": "Профиль медсестры не найден. Обратитесь к администратору.",
  "nurse.tasks.tab.todo": "В работе",
  "nurse.tasks.tab.today": "Сегодня",
  "nurse.tasks.tab.done": "Завершены",
  "nurse.tasks.empty": "Список пуст",
  "nurse.tasks.table.task": "Задача",
  "nurse.tasks.table.patient": "Пациент",
  "nurse.tasks.table.service": "Сервис",
  "nurse.tasks.table.scheduled": "Запланировано",
  "nurse.tasks.table.deadline": "Крайний срок",
  "nurse.tasks.table.details": "Подробнее",
  "nurse.tasks.badge.notToday": "Не сегодня",
  "nurse.tasks.untitled": "Без названия",
  "nurse.tasks.dialog.titleFallback": "Задача",
  "nurse.tasks.dialog.description": "Просмотрите детали задания перед тем, как отметить его выполненным.",
  "nurse.tasks.dialog.detailsNotFound": "Детали задачи не найдены",
  "nurse.tasks.dialog.updatingDetails": "Обновляем данные о пациенте и услуге...",
  "nurse.tasks.dialog.patient": "Пациент",
  "nurse.tasks.dialog.service": "Сервис",
  "nurse.tasks.dialog.scheduled": "Запланировано",
  "nurse.tasks.dialog.deadline": "Крайний срок",
  "nurse.tasks.dialog.descriptionLabel": "Описание",
  "nurse.tasks.dialog.cardNumber": "Карта #{{number}}",
  "nurse.tasks.dialog.close": "Закрыть",
  "nurse.tasks.dialog.alreadyDone": "Задача уже отмечена как выполненная.",
  "nurse.tasks.dialog.onlyFromTodo": "Отметить выполненной можно только из вкладки с задачами в работе.",
  "nurse.tasks.dialog.onlyToday": "Отметить выполненными можно только задания, запланированные на сегодня.",
  "nurse.tasks.dialog.completeButton.completed": "Уже выполнено",
  "nurse.tasks.dialog.completeButton.markDone": "Отметить выполненной",
  "nurse.tasks.dialog.alreadyCompletedToast": "Задача уже завершена",
  "nurse.tasks.dialog.cannotCompleteEarlyTitle": "Нельзя завершить задачу заранее",
  "nurse.tasks.dialog.cannotCompleteEarlyDescription": "Отметить выполненными можно только задания, запланированные на сегодня.",
  "nurse.tasks.toast.done": "Задача завершена",
  "nurse.tasks.toast.updateError": "Не удалось обновить задачу",
  "nurse.tasks.fallback.service": "Услуга #{{id}}",
  "nurse.tasks.fallback.medicine": "Препарат #{{id}}",
  "nurse.tasks.fallback.pet": "Питомец #{{id}}",

  // Nurse Salary tab
  "nurse.tabs.salaryHistory": "История зарплаты",
  "nurse.salary.weeklyTitle": "История зарплаты за неделю",
  "nurse.salary.monthlyTitle": "История зарплаты за месяц",
  "nurse.salary.loading": "Загрузка истории зарплаты...",
  "nurse.salary.empty": "Нет событий по зарплате",
  "nurse.salary.table.date": "Дата",
  "nurse.salary.table.amount": "Сумма",

  // Moderator dashboard - additional strings
  "moderator.banner.subtitle": "Панель модератора клиники",
  "moderator.banner.fallbackRole": "Модератор",
  "moderator.banner.changeImage": "Изменить",
  "moderator.banner.uploading": "Загрузка…",
  "moderator.tabs.clients": "Клиенты",
  "moderator.tabs.addUser": "Добавить пользователя",
  "moderator.tabs.nurseCare": "Nurse Care",
  "moderator.tabs.feedSales": "Продажа кормов",
  "moderator.tabs.feedInventory": "Склад кормов",
  "moderator.clients.title": "Клиенты",
  "moderator.clients.subtitle": "Список всех клиентов клиники",
  "moderator.clients.filter.id": "ID клиента",
  "moderator.clients.filter.idPlaceholder": "Например: 123",
  "moderator.clients.filter.name": "Имя или фамилия",
  "moderator.clients.filter.namePlaceholder": "Имя или фамилия клиента",
  "moderator.clients.filter.phone": "Телефон",
  "moderator.clients.filter.phonePlaceholder": "Поиск по телефону",
  "moderator.clients.table.id": "ID",
  "moderator.clients.table.firstName": "Имя",
  "moderator.clients.table.lastName": "Фамилия",
  "moderator.clients.table.phone": "Телефон",
  "moderator.clients.table.extraPhone1": "Доп. телефон 1",
  "moderator.clients.table.extraPhone2": "Доп. телефон 2",
  "moderator.clients.empty": "Нет клиентов для отображения",
  "moderator.addUser.title": "Регистрация нового клиента",
  "moderator.addUser.subtitle": "Создайте клиента, указав телефон и пароль. Имя и фамилия — необязательно.",
  "moderator.addUser.phone": "Телефон",
  "moderator.addUser.phonePlaceholder": "+998901234567",
  "moderator.addUser.password": "Пароль",
  "moderator.addUser.passwordPlaceholder": "Минимум 6 символов",
  "moderator.addUser.passwordShow": "Показать пароль",
  "moderator.addUser.passwordHide": "Скрыть пароль",
  "moderator.addUser.firstName": "Имя (необязательно)",
  "moderator.addUser.lastName": "Фамилия (необязательно)",
  "moderator.addUser.submit": "Создать клиента",
  "moderator.addUser.phoneInvalid": "Неверный формат телефона",
  "moderator.addUser.phoneUsed": "Этот номер уже используется",
  "moderator.addUser.checkingPhone": "Проверка номера…",
  "moderator.addUser.validation.required": "Проверьте поля",
  "moderator.addUser.validation.requiredDesc": "Телефон и пароль обязательны",
  "moderator.addUser.validation.phoneInvalid": "Телефон некорректен",
  "moderator.addUser.validation.phoneInvalidDesc": "Проверьте номер телефона",
  "moderator.addUser.success": "Клиент создан",
  "moderator.addUser.error": "Ошибка",
  "moderator.addUser.errorDesc": "Не удалось создать клиента",
  "moderator.visits.create.client": "Клиент",
  "moderator.visits.create.clientPlaceholder": "Выберите клиента",
  "moderator.visits.create.doctor": "Врач",
  "moderator.visits.create.doctorPlaceholder": "Выберите врача",
  "moderator.visits.create.pet": "Питомец",
  "moderator.visits.create.petPlaceholder": "Выберите питомца",
  "moderator.visits.create.validation": "Проверьте поля",
  "moderator.visits.create.validationDesc": "Выберите клиента и врача",
  "moderator.visits.create.success": "Визит создан",
  "moderator.visits.create.error": "Ошибка",
  "moderator.visits.create.errorDesc": "Не удалось создать визит",
  "moderator.visits.table.date": "Дата",
  "moderator.visits.table.client": "Клиент",
  "moderator.visits.table.doctor": "Врач",
  "moderator.visits.table.pet": "Питомец",
  "moderator.requests.table.id": "ID",
  "moderator.requests.table.firstName": "Имя",
  "moderator.requests.table.lastName": "Фамилия",
  "moderator.requests.table.phone": "Телефон",
  "moderator.requests.table.created": "Создано",
  "moderator.card.table.id": "ID",
  "moderator.card.table.client": "Клиент",
  "moderator.card.table.pet": "Питомец",
  "moderator.card.table.amount": "Сумма",
  "moderator.card.table.status": "Статус",
  "moderator.card.table.actions": "Действия",
  "moderator.card.partlyPaid.title": "Карты с частичной оплатой",
  "moderator.card.partlyPaid.status": "Статус: PARTLY_PAID",
  "moderator.card.partlyPaid.table.total": "Всего",
  "moderator.card.partlyPaid.table.paid": "Оплачено",
  "moderator.card.partlyPaid.table.outstanding": "Остаток",
  "moderator.card.modal.paid": "Оплачено",
  "moderator.card.modal.outstanding": "Остаток к оплате",
  "moderator.card.modal.progress": "Прогресс оплаты",
  "moderator.card.modal.anamnesis": "Анамнез",
  "moderator.card.modal.recommendedFeed": "Рекомендованный корм врача",
  "moderator.card.modal.feeTotal": "Всего (total_fee)",
  "moderator.card.modal.feeStationary": "Стационар (stationary_fee)",
  "moderator.card.modal.feeMedicines": "Препараты (medicines_fee)",
  "moderator.card.modal.feeServices": "Услуги (services_fee)",
  "moderator.card.modal.servicesTitle": "Использованные услуги",
  "moderator.card.modal.servicesTable.service": "Услуга",
  "moderator.card.modal.servicesTable.quantity": "Кол-во",
  "moderator.card.modal.servicesTable.price": "Цена",
  "moderator.card.modal.servicesTable.total": "Сумма",
  "moderator.card.modal.medicinesTitle": "Использованные препараты",
  "moderator.card.modal.medicinesTable.medicine": "Препарат",
  "moderator.card.modal.medicinesTable.quantity": "Кол-во",
  "moderator.card.modal.medicinesTable.price": "Цена",
  "moderator.card.modal.medicinesTable.total": "Сумма",
  "moderator.card.modal.paymentsTitle": "Платежи",
  "moderator.card.modal.paymentsTable.date": "Дата",
  "moderator.card.modal.paymentsTable.method": "Метод",
  "moderator.card.modal.paymentsTable.amount": "Сумма",
  "moderator.card.modal.paymentsTable.note": "Комментарий",
  "moderator.card.modal.paymentsTable.recordedBy": "Кем принят",
  "moderator.card.modal.paymentsEmpty": "Платежей пока нет",
  "moderator.card.modal.paymentAmount": "Сумма платежа",
  "moderator.card.modal.paymentMethod": "Метод оплаты",
  "moderator.card.modal.paymentMethod.cash": "Наличные",
  "moderator.card.modal.paymentMethod.card": "Картой",
  "moderator.card.modal.paymentMethod.transfer": "Перевод",
  // Legacy keys for backward compatibility
  "moderator.card.modal.paymentMethod.click": "Click",
  "moderator.card.modal.paymentMethod.payme": "Payme",
  "moderator.card.modal.paymentMethod.other": "Другое",
  "moderator.card.modal.paymentNote": "Комментарий (необязательно)",
  "moderator.card.modal.paymentNotePlaceholder": "Например: первая часть платежа",
  "moderator.card.modal.confirmFullPayment": "Полностью оплачен",
  "moderator.card.modal.acceptPartialPayment": "Принять частичный платеж",
  "moderator.card.modal.paymentValidation.amountRequired": "Некорректная сумма",
  "moderator.card.modal.paymentValidation.amountRequiredDesc": "Введите сумму больше нуля",
  "moderator.card.modal.paymentValidation.amountExceeds": "Сумма больше остатка",
  "moderator.card.modal.paymentValidation.methodRequired": "Метод оплаты",
  "moderator.card.modal.paymentValidation.methodRequiredDesc": "Выберите метод оплаты",
  "moderator.card.modal.paymentSuccess": "Платеж принят",
  "moderator.card.modal.paymentError": "Ошибка оплаты",
  "moderator.errors.loadCards": "Не удалось загрузить карты",
  "moderator.errors.loadItems": "Не удалось загрузить позиции карты",
  "moderator.errors.loadPayments": "Не удалось загрузить платежи",
  "moderator.errors.loadVisits": "Не удалось загрузить визиты",
  "moderator.errors.loadClients": "Не удалось загрузить клиентов",
  "moderator.errors.loadRequests": "Не удалось загрузить запросы",
  "moderator.errors.updatePhoto": "Не удалось обновить фото",
  "moderator.errors.updatePhotoDesc": "Не удалось обновить фото",
  "moderator.photo.updated": "Фото обновлено",
  "moderator.kpi.quantityGreaterThanZero": "quantity > 0",
  "moderator.select.loading": "Загрузка…",
  "moderator.select.client": "Выберите клиента",
  "moderator.select.doctor": "Выберите врача",
  "moderator.select.pet": "Выберите питомца",

  // Client dashboard - Nurse Care tab
  "client.tabs.nurseCare": "Карточки ухода",
  "client.tabs.nurseCareShort": "Карточки",
  "client.tabs.historyCards": "Карты истории",
  "client.tabs.historyCardsShort": "История",

  // Nurse dashboard - Nurse Care tab
  "nurse.tabs.nurseCare": "Nurse Care 💗",
  "nurse.tabs.nurseCareShort": "Nurse 💗",
  "nurse.medicines.itemFallback": "Позиция #{{id}}",
  "nurse.medicines.untitled": "Без названия",

  // Admin dashboard
  "admin.banner.goHome": "Вернуться на главную",
  "admin.message.useAdminPanel": "Для управления системой используйте административную панель ELVET.",
  "admin.message.urlNotConfigured": "URL панели администратора не настроен. Обратитесь к разработчику.",
  "admin.button.openAdmin": "ELVET ADMIN",

  // Doctor dashboard - feed recommendation placeholder
  "doctor.feed.recommendationPlaceholder": "Например: JOSERA Catelux, 0.5 кг в день на 14 дней",
  "doctor.edit.attachments.add": "Добавить вложения",

  // Client PetsManager - animal type labels
  "client.pets.animalType.dog": "🐕 Собака",
  "client.pets.animalType.cat": "🐈 Кошка",
  "client.pets.animalType.bird": "🦜 Птица",
  "client.pets.animalType.other": "🐾 Другое",
  "client.pets.colorPlaceholder": "Рыжий",
  "client.pets.descriptionPlaceholder": "Особенности, аллергии...",

  // Client MedicalCardsViewer - column headers and labels
  "client.medicalCards.column.waiting": "Ожидающие оплаты",
  "client.medicalCards.column.partlyPaid": "Частично оплаченные",
  "client.medicalCards.column.fullyPaid": "Полностью оплаченные",
  "client.medicalCards.currency.sum": "сум",
  "client.medicalCards.attachments": "Вложения",
  "client.medicalCards.attachments.downloadAll": "Скачать всё",
  "client.medicalCards.attachments.download": "Скачать",
  "client.medicalCards.attachments.xrays": "Рентген-снимки",
  "client.medicalCards.attachments.files": "Файлы",
  "client.medicalCards.attachments.open": "Открыть",
  "client.medicalCards.attachments.openFile": "Открыть",

  // Client NurseCareCardsViewer
  "client.nurseCare.title": "Карточки ухода",
  "client.nurseCare.subtitle": "Просмотр истории ухода медсестры",
  "client.nurseCare.loading": "Загрузка…",
  "client.nurseCare.error": "Не удалось загрузить",
  "client.nurseCare.empty": "Карт ухода пока нет",
  "client.nurseCare.column.waiting": "Ожидающие оплаты",
  "client.nurseCare.column.partlyPaid": "Частично оплаченные",
  "client.nurseCare.column.fullyPaid": "Полностью оплаченные",
  "client.nurseCare.status.waiting": "Ожидает оплаты",
  "client.nurseCare.status.partlyPaid": "Частично оплачено",
  "client.nurseCare.status.fullyPaid": "Полностью оплачено",
  "client.nurseCare.cardNumber": "Карта #{{id}}",
  "client.nurseCare.nurseNumber": "Медсестра #{{id}}",
  "client.nurseCare.servicesEmpty": "Нет услуг",
  "client.nurseCare.total": "Всего:",
  "client.nurseCare.paid": "Оплачено:",
  "client.nurseCare.remain": "Остаток:",

  // Client HistoryCardsViewer (unified medical + nurse cards)
  "client.historyCards.title": "Карты истории",
  "client.historyCards.subtitle": "Все медицинские и карты ухода в одном месте",
  "client.historyCards.filterByStatus": "Фильтр по статусу оплаты",
  "client.historyCards.status.waiting": "Ожидает оплаты",
  "client.historyCards.status.waitingShort": "Ожидает",
  "client.historyCards.status.partlyPaid": "Частично оплачено",
  "client.historyCards.status.partlyPaidShort": "Частично",
  "client.historyCards.status.fullyPaid": "Полностью оплачено",
  "client.historyCards.status.fullyPaidShort": "Оплачено",
  "client.historyCards.badge.medical": "Медицинская",
  "client.historyCards.badge.medicalShort": "Мед",
  "client.historyCards.badge.nurseCare": "Уход",
  "client.historyCards.badge.nurseCareShort": "Уход",
  "client.historyCards.empty": "Карты не найдены",
  "client.historyCards.emptyHint": "Попробуйте выбрать другой статус оплаты",

  // Moderator NurseCareCardsManager
  "moderator.nurseCare.title": "Карты ухода медсестры",
  "moderator.nurseCare.description": "Создавайте карты и фиксируйте платежи.",
  "moderator.nurseCare.allCards": "Все карты",
  "moderator.nurseCare.refresh": "Обновить",
  "moderator.nurseCare.loading": "Загрузка…",
  "moderator.nurseCare.noCards": "Нет карт",
  "moderator.nurseCare.cardNumber": "Карта #{{id}}",
  "moderator.nurseCare.paidInfo": "Оплачено {{paid}} / {{total}} · Остаток {{remain}}",
  "moderator.nurseCare.createCard": "Создать карту",
  "moderator.nurseCare.client": "Клиент",
  "moderator.nurseCare.selectClient": "Выберите клиента",
  "moderator.nurseCare.pet": "Животное",
  "moderator.nurseCare.selectPet": "Выберите животное",
  "moderator.nurseCare.nurse": "Медсестра",
  "moderator.nurseCare.selectNurse": "Выберите медсестру",
  "moderator.nurseCare.descriptionLabel": "Описание",
  "moderator.nurseCare.descriptionPlaceholder": "Необязательно",
  "moderator.nurseCare.create": "Создать",
  "moderator.nurseCare.recordPayment": "Записать платеж",
  "moderator.nurseCare.selectCardMessage": "Выберите карту для записи платежа.",
  "moderator.nurseCare.total": "Всего:",
  "moderator.nurseCare.paid": "Оплачено:",
  "moderator.nurseCare.remain": "Остаток:",
  "moderator.nurseCare.amount": "Сумма",
  "moderator.nurseCare.amountPlaceholder": "например, 40000",
  "moderator.nurseCare.method": "Метод",
  "moderator.nurseCare.selectMethod": "Выберите метод",
  "moderator.nurseCare.record": "Записать",
  "moderator.nurseCare.errors.loadFailed": "Не удалось загрузить карты",
  "moderator.nurseCare.errors.missingFields": "Не заполнены поля",
  "moderator.nurseCare.errors.selectClientPetNurse": "Выберите клиента и медсестру",
  "moderator.nurseCare.success.created": "Создано",
  "moderator.nurseCare.success.createdDesc": "Карта ухода медсестры создана",
  "moderator.nurseCare.errors.createFailed": "Не удалось создать",
  "moderator.nurseCare.errors.enterAmountMethod": "Введите сумму и метод",
  "moderator.nurseCare.success.recorded": "Записано",
  "moderator.nurseCare.success.recordedDesc": "Платеж записан",
  "moderator.nurseCare.errors.recordFailed": "Не удалось записать платеж",

  // Client ProfileEditor - phone placeholder
  "client.profile.phonePlaceholder": "+998 90 123 45 67",
  "client.profile.nameSeparator": ":",

  // Moderator sidebar navigation
  "moderator.sidebar.navigation": "Навигация",
  "moderator.sidebar.main": "Главная",
  "moderator.sidebar.medicalCards": "Медицинские карты",
  "moderator.sidebar.visits": "Визиты",
  "moderator.sidebar.requests": "Заявки",
  "moderator.sidebar.clients": "Клиенты",
  "moderator.sidebar.addClient": "Добавить клиента",
  "moderator.sidebar.nurseCare": "Уход медсестры",
  "moderator.sidebar.feedSales": "Продажа кормов",
  "moderator.sidebar.feedInventory": "Склад кормов",
  "moderator.sidebar.medicines": "Склад препаратов",
  "moderator.sidebar.staffIncome": "Доход персонала",
  "moderator.sidebar.collapse": "Свернуть",
  "moderator.sidebar.expand": "Развернуть",
  "moderator.sidebar.hint": "Панель регистратора",

  // Moderator staff income dashboard
  "moderator.staffIncome.title": "Доходы и выплаты персонала",
  "moderator.staffIncome.description": "Ежедневный заработок врачей и медсестёр",
  "moderator.staffIncome.date": "Дата",
  "moderator.staffIncome.search": "Поиск",
  "moderator.staffIncome.searchPlaceholder": "Поиск по имени или ID...",
  "moderator.staffIncome.filterRole": "Фильтр по роли",
  "moderator.staffIncome.allRoles": "Все роли",
  "moderator.staffIncome.doctors": "Врачи",
  "moderator.staffIncome.nurses": "Медсёстры",
  "moderator.staffIncome.refresh": "Обновить",
  "moderator.staffIncome.go": "Применить",
  "moderator.staffIncome.totalStaff": "Всего сотрудников",
  "moderator.staffIncome.totalEarned": "Общий заработок",
  "moderator.staffIncome.paidOut": "Выплачено",
  "moderator.staffIncome.pendingPay": "Ожидает выплаты",
  "moderator.staffIncome.col.id": "ID",
  "moderator.staffIncome.col.name": "Имя",
  "moderator.staffIncome.col.role": "Роль",
  "moderator.staffIncome.col.earned": "Заработано",
  "moderator.staffIncome.col.status": "Статус",
  "moderator.staffIncome.col.action": "Действие",
  "moderator.staffIncome.role.doctor": "Врач",
  "moderator.staffIncome.role.nurse": "Медсестра",
  "moderator.staffIncome.status.paid": "Выплачено",
  "moderator.staffIncome.status.unpaid": "Не выплачено",
  "moderator.staffIncome.pay": "Выплатить",
  "moderator.staffIncome.paying": "Выплата...",
  "moderator.staffIncome.alreadyPaid": "Выплачено",
  "moderator.staffIncome.empty.noData": "Нет данных по зарплате за эту дату",
  "moderator.staffIncome.empty.noMatch": "Нет сотрудников по вашим фильтрам",
  "moderator.staffIncome.paySuccess": "Выплата зарегистрирована",
  "moderator.staffIncome.payError": "Ошибка выплаты",
  "moderator.staffIncome.loadError": "Не удалось загрузить данные",

  // Medicine storage
  "storage.title": "Склад препаратов",
  "storage.adminIntro": "Приход, списание, инвентаризация и цены. Всё, что врачи используют, списывается со склада автоматически.",
  "storage.subtitleView": "Что есть на складе прямо сейчас",
  "storage.add": "Добавить препарат",
  "storage.searchPlaceholder": "Поиск препарата…",
  "storage.loadError": "Не удалось загрузить склад",
  "storage.retry": "Повторить",
  "storage.note": "Комментарий",
  "storage.summary.total": "Всего позиций",
  "storage.summary.out": "Нет в наличии",
  "storage.summary.low": "Заканчивается",
  "storage.summary.expiring": "Истекает ≤ {{days}} дн.",
  "storage.summary.expired": "Есть просроченные",
  "storage.summary.noPrice": "Без цены",
  "storage.filter.allTypes": "Все типы",
  "storage.filter.showInactive": "Показать неактивные",
  "storage.table.name": "Препарат",
  "storage.table.stock": "В наличии",
  "storage.table.price": "Цена продажи",
  "storage.table.expiry": "Ближайший срок",
  "storage.table.actions": "Действия",
  "storage.status.out": "Нет в наличии",
  "storage.status.low": "Мало",
  "storage.status.inactive": "Неактивен",
  "storage.status.noPrice": "Цена не указана",
  "storage.status.expired": "Просрочено",
  "storage.status.expiredQty": "Просрочено: {{qty}}",
  "storage.actions.receive": "Приход",
  "storage.actions.writeOff": "Списать",
  "storage.actions.count": "Инвентаризация",
  "storage.actions.history": "История и партии",
  "storage.actions.edit": "Изменить",
  "storage.unit.PIECE": "шт.",
  "storage.unit.TABLET": "таб.",
  "storage.unit.CAPSULE": "капс.",
  "storage.unit.AMPOULE": "амп.",
  "storage.unit.SACHET": "саше",
  "storage.unit.ML": "мл",
  "storage.unit.MG": "мг",
  "storage.unit.G": "г",
  "storage.unitName.PIECE": "Штука",
  "storage.unitName.TABLET": "Таблетка / каплета",
  "storage.unitName.CAPSULE": "Капсула",
  "storage.unitName.AMPOULE": "Ампула",
  "storage.unitName.SACHET": "Саше / пакетик",
  "storage.unitName.ML": "Миллилитр (мл)",
  "storage.unitName.MG": "Миллиграмм (мг)",
  "storage.unitName.G": "Грамм (г)",
  "storage.package.PIECE": "шт.",
  "storage.package.PACK": "уп.",
  "storage.package.BLISTER": "блист.",
  "storage.package.VIAL": "фл.",
  "storage.package.BOTTLE": "бут.",
  "storage.package.TUBE": "туб.",
  "storage.packageName.PIECE": "Штука",
  "storage.packageName.PACK": "Упаковка / коробка",
  "storage.packageName.BLISTER": "Блистер",
  "storage.packageName.VIAL": "Флакон",
  "storage.packageName.BOTTLE": "Бутылка",
  "storage.packageName.TUBE": "Тюбик",
  "storage.form.createTitle": "Новый препарат",
  "storage.form.editTitle": "Изменить препарат",
  "storage.form.subtitle": "Выберите, как препарат расходуется — от этого зависит учёт остатка и цена.",
  "storage.form.name": "Название",
  "storage.form.namePlaceholder": "Например: Синулокс 50 мг",
  "storage.form.type": "Тип учёта",
  "storage.form.types.WHOLE.title": "Целая единица",
  "storage.form.types.WHOLE.hint": "Продаётся только целиком: паста, ошейник, шприц, спрей.",
  "storage.form.types.COUNTABLE.title": "Штучные в упаковке",
  "storage.form.types.COUNTABLE.hint": "Таблетки, капсулы, ампулы. Можно продать часть упаковки.",
  "storage.form.types.MEASURED.title": "Жидкие / по весу",
  "storage.form.types.MEASURED.hint": "Учёт в мл, мг или г. Врач берёт нужный объём, остаток остаётся.",
  "storage.form.unitLocked": "Тип и единицу нельзя менять, пока на складе есть остаток или история.",
  "storage.form.unit": "Единица учёта",
  "storage.form.packageUnit": "Упаковка",
  "storage.form.packageSize": "Сколько {{unit}} в 1 {{package}}",
  "storage.form.price": "Цена продажи, сум",
  "storage.form.pricePer": "За сколько {{unit}} эта цена",
  "storage.form.doseStep": "Минимальная порция",
  "storage.form.doseStepHint": "Врач сможет выписывать количество, кратное этому шагу (например, ½ таблетки или 0.01 мл).",
  "storage.form.example": "Пример: врач использует {{qty}} → клиент платит {{price}}",
  "storage.form.minStock": "Предупреждать, когда осталось ≤ ({{unit}})",
  "storage.form.minStockHint": "0 — без предупреждения",
  "storage.form.active": "Используется",
  "storage.form.description": "Описание",
  "storage.form.errorName": "Укажите название",
  "storage.form.errorPrice": "Укажите цену",
  "storage.form.created": "Препарат добавлен",
  "storage.form.updated": "Изменения сохранены",
  "storage.form.saveError": "Не удалось сохранить",
  "storage.receive.title": "Приход на склад",
  "storage.receive.packages": "Целых {{package}} (по {{size}})",
  "storage.receive.quantity": "Количество, {{unit}}",
  "storage.receive.loose": "Плюс отдельно, {{unit}}",
  "storage.receive.total": "Будет добавлено",
  "storage.receive.expireDate": "Срок годности",
  "storage.receive.batchNumber": "Серия / партия",
  "storage.receive.purchasePrice": "Закупочная цена за {{package}}",
  "storage.receive.submit": "Оприходовать",
  "storage.receive.done": "Добавлено {{qty}}",
  "storage.receive.error": "Не удалось оприходовать",
  "storage.receive.errorEmpty": "Укажите количество",
  "storage.writeOff.title": "Списание",
  "storage.writeOff.batch": "Партия",
  "storage.writeOff.batchAuto": "Автоматически (сначала старые)",
  "storage.writeOff.batchOption": "годен до {{expiry}} — {{qty}}",
  "storage.writeOff.quantity": "Количество, {{unit}}",
  "storage.writeOff.reason": "Причина",
  "storage.writeOff.submit": "Списать",
  "storage.writeOff.done": "Списано {{qty}}",
  "storage.writeOff.error": "Не удалось списать",
  "storage.reason.EXPIRED": "Истёк срок",
  "storage.reason.DAMAGED": "Повреждено / разбито",
  "storage.reason.LOST": "Утеряно",
  "storage.reason.OTHER": "Другое",
  "storage.adjust.title": "Инвентаризация",
  "storage.adjust.subtitle": "Пересчитайте {{name}} на полке и введите фактический остаток.",
  "storage.adjust.inSystem": "По системе",
  "storage.adjust.counted": "Фактически, {{unit}}",
  "storage.adjust.difference": "Разница: {{qty}}",
  "storage.adjust.noDifference": "Расхождений нет",
  "storage.adjust.done": "Остаток исправлен",
  "storage.adjust.error": "Не удалось сохранить",
  "storage.history.batches": "Партии",
  "storage.history.journal": "Журнал движений",
  "storage.history.noBatches": "Остатков нет",
  "storage.history.noMovements": "Движений пока нет",
  "storage.history.received": "Поступило",
  "storage.history.expiry": "Годен до",
  "storage.history.remaining": "Осталось / было",
  "storage.history.cost": "Закупка",
  "storage.history.when": "Когда",
  "storage.history.operation": "Операция",
  "storage.history.quantity": "Количество",
  "storage.history.details": "Подробности",
  "storage.history.who": "Кто",
  "storage.history.card": "Карта №{{id}}",
  "storage.kind.RECEIPT": "Приход",
  "storage.kind.DISPENSE": "Использовано",
  "storage.kind.RETURN": "Возврат",
  "storage.kind.WRITE_OFF": "Списание",
  "storage.kind.ADJUSTMENT": "Инвентаризация",
  "storage.dose.add": "Добавить препарат",
  "storage.dose.noLines": "Препараты не добавлены",
  "storage.dose.inStock": "На складе",
  "storage.dose.notePlaceholder": "Как применять (в/м, 2 раза в день…)",
  "storage.dose.total": "Итого за препараты",
  "storage.dose.errorPositive": "Укажите количество больше нуля",
  "storage.dose.errorStep": "Количество должно быть кратно {{step}}",
  "storage.dose.errorStock": "На складе только {{available}}",
  "storage.dose.errorNoPrice": "У препарата не указана цена",
  "storage.dose.fixErrors": "Проверьте препараты",
  "storage.dose.saveFailed": "Не все препараты сохранены",

  // Admin panel
  "adminPanel.title": "Панель администратора",
  "adminPanel.menu": "Меню",
  "adminPanel.refresh": "Обновить",
  "adminPanel.refreshing": "Обновление…",
  "adminPanel.group.main": "Главное",
  "adminPanel.group.money": "Деньги",
  "adminPanel.group.people": "Люди",
  "adminPanel.group.catalog": "Склад и прайс",
  "adminPanel.nav.overview": "Обзор",
  "adminPanel.nav.cards": "Медкарты",
  "adminPanel.nav.finance": "Финансы",
  "adminPanel.nav.salaries": "Зарплаты",
  "adminPanel.nav.staff": "Сотрудники",
  "adminPanel.nav.clients": "Клиенты",
  "adminPanel.nav.requests": "Заявки с сайта",
  "adminPanel.nav.storage": "Склад препаратов",
  "adminPanel.nav.services": "Услуги и цены",
  "adminPanel.nav.stationary": "Стационар",
  "adminPanel.nav.feeds": "Корма",
  "adminPanel.nav.doctor": "Кабинет врача",
  "adminPanel.nav.django": "Расширенная админка",
  "adminPanel.common.add": "Добавить",
  "adminPanel.common.edit": "Изменить",
  "adminPanel.common.actions": "Действия",
  "adminPanel.common.search": "Поиск…",
  "adminPanel.common.total": "Всего: {{count}}",
  "adminPanel.common.loadError": "Не удалось загрузить данные",
  "adminPanel.common.saved": "Сохранено",
  "adminPanel.common.saveError": "Не удалось сохранить",
  "adminPanel.common.deleted": "Удалено",
  "adminPanel.common.deleteError": "Не удалось удалить",
  "adminPanel.common.deleteTitle": "Удалить запись?",
  "adminPanel.common.deleteText": "Это действие нельзя отменить.",
  "adminPanel.common.required": "Заполните поле «{{field}}»",
  "adminPanel.common.passwordKeep": "Оставьте пустым, чтобы не менять",
  "adminPanel.common.on": "Активно",
  "adminPanel.common.off": "Выключено",
  "adminPanel.fields.name": "Название / имя",
  "adminPanel.fields.firstName": "Имя",
  "adminPanel.fields.lastName": "Фамилия",
  "adminPanel.fields.phone": "Телефон",
  "adminPanel.fields.extraPhone": "Доп. телефон",
  "adminPanel.fields.password": "Пароль",
  "adminPanel.fields.passwordHint": "Минимум 6 символов. При изменении — новый пароль.",
  "adminPanel.fields.status": "Статус",
  "adminPanel.fields.specialization": "Специализация",
  "adminPanel.fields.experience": "Стаж, лет",
  "adminPanel.fields.workStart": "Начало работы",
  "adminPanel.fields.fixedSalary": "Фикс. зарплата",
  "adminPanel.fields.description": "Описание",
  "adminPanel.fields.address": "Адрес",
  "adminPanel.fields.registered": "Зарегистрирован",
  "adminPanel.fields.price": "Цена",
  "adminPanel.fields.date": "Дата",
  "adminPanel.fields.doctor": "Врач",
  "adminPanel.overview.period": "Период",
  "adminPanel.overview.days": "{{count}} дн.",
  "adminPanel.overview.income": "Доход за период",
  "adminPanel.overview.expenses": "Расходы за период",
  "adminPanel.overview.net": "Чистая прибыль",
  "adminPanel.overview.unpaid": "Долги клиентов",
  "adminPanel.overview.cards": "Медкарты",
  "adminPanel.overview.newClients": "Новые клиенты",
  "adminPanel.overview.today": "Сегодня: {{value}}",
  "adminPanel.overview.thisMonth": "В этом месяце: {{value}}",
  "adminPanel.overview.unpaidCards": "Неоплаченных карт: {{count}}",
  "adminPanel.overview.todayCount": "Сегодня: {{count}}",
  "adminPanel.overview.clientsTotal": "Всего клиентов: {{count}}",
  "adminPanel.overview.attention": "Требует внимания:",
  "adminPanel.overview.alertOut": "Нет в наличии: {{count}}",
  "adminPanel.overview.alertLow": "Заканчивается: {{count}}",
  "adminPanel.overview.alertExpiring": "Истекает срок: {{count}}",
  "adminPanel.overview.alertUnpaid": "Неоплаченные карты: {{count}}",
  "adminPanel.overview.alertRequests": "Заявки: {{count}}",
  "adminPanel.overview.dailyTitle": "Доходы и расходы по дням",
  "adminPanel.overview.dailyHint": "Все поступления клиники и записанные расходы",
  "adminPanel.overview.monthlyTitle": "Последние 12 месяцев",
  "adminPanel.overview.monthlyHint": "Доходы и расходы по месяцам",
  "adminPanel.overview.cardsTitle": "Медкарты по дням",
  "adminPanel.overview.cardsHint": "Сколько приёмов было каждый день",
  "adminPanel.overview.methodsTitle": "Способы оплаты",
  "adminPanel.overview.methodsHint": "Оплаты медкарт и ухода за период",
  "adminPanel.overview.servicesTitle": "Самые доходные услуги",
  "adminPanel.overview.servicesHint": "Топ-8 за период",
  "adminPanel.overview.medicinesTitle": "Самые используемые препараты",
  "adminPanel.overview.medicinesHint": "По выручке за период",
  "adminPanel.overview.doctorsTitle": "Работа врачей",
  "adminPanel.overview.doctorsHint": "Медкарты, сумма счетов и заработок врача за период",
  "adminPanel.overview.revenue": "Выручка",
  "adminPanel.overview.earned": "Заработал врач",
  "adminPanel.overview.used": "Использовано",
  "adminPanel.overview.noData": "Нет данных за период",
  "adminPanel.cards.hint": "Все медкарты клиники. Нажмите на строку, чтобы открыть карту и принять оплату.",
  "adminPanel.cards.search": "Поиск: №, клиент, питомец, врач",
  "adminPanel.cards.allStatuses": "Все статусы",
  "adminPanel.cards.status.OPEN": "Открыта",
  "adminPanel.cards.status.WAITING_FOR_PAYMENT": "Ожидает оплаты",
  "adminPanel.cards.status.PARTLY_PAID": "Частично оплачена",
  "adminPanel.cards.status.FULLY_PAID": "Оплачена",
  "adminPanel.cards.card": "Карта",
  "adminPanel.cards.client": "Клиент",
  "adminPanel.cards.pet": "Питомец",
  "adminPanel.cards.total": "Сумма",
  "adminPanel.cards.debt": "Долг",
  "adminPanel.cards.services": "Услуги",
  "adminPanel.cards.medicines": "Препараты",
  "adminPanel.cards.stationary": "Стационар",
  "adminPanel.cards.anamnez": "Анамнез",
  "adminPanel.cards.diagnosis": "Диагноз",
  "adminPanel.cards.prescriptions": "Назначения",
  "adminPanel.cards.payments": "Оплаты",
  "adminPanel.cards.noPayments": "Оплат пока нет",
  "adminPanel.cards.paidSoFar": "Оплачено",
  "adminPanel.cards.receive": "Принять оплату",
  "adminPanel.cards.receiveButton": "Принять",
  "adminPanel.cards.paid": "Принято {{amount}}",
  "adminPanel.cards.payError": "Не удалось принять оплату",
  "adminPanel.finance.day": "День",
  "adminPanel.finance.month": "Месяц",
  "adminPanel.finance.year": "Год",
  "adminPanel.finance.income": "Доход",
  "adminPanel.finance.expenses": "Расходы",
  "adminPanel.finance.net": "Чистая прибыль",
  "adminPanel.finance.expensesTab": "Расходы",
  "adminPanel.finance.paymentsTab": "История оплат",
  "adminPanel.finance.expensesHint": "Аренда, коммунальные, закупки. Зарплаты попадают сюда автоматически при выплате.",
  "adminPanel.finance.paymentsHint": "Все оплаты по медкартам",
  "adminPanel.finance.addExpense": "Добавить расход",
  "adminPanel.finance.amount": "Сумма",
  "adminPanel.finance.categoryLabel": "Категория",
  "adminPanel.finance.methodLabel": "Способ оплаты",
  "adminPanel.finance.note": "Комментарий",
  "adminPanel.finance.method.CASH": "Наличные",
  "adminPanel.finance.method.CARD": "Карта",
  "adminPanel.finance.method.TRANSFER": "Перевод",
  "adminPanel.finance.category.SALARY": "Зарплата",
  "adminPanel.finance.category.MEDICINE": "Закупка препаратов",
  "adminPanel.finance.category.FEED": "Закупка кормов",
  "adminPanel.finance.category.RENT": "Аренда",
  "adminPanel.finance.category.UTILITIES": "Коммунальные",
  "adminPanel.finance.category.EQUIPMENT": "Оборудование",
  "adminPanel.finance.category.OTHER": "Другое",
  "adminPanel.staff.doctors": "Врачи",
  "adminPanel.staff.nurses": "Медсёстры",
  "adminPanel.staff.moderators": "Администраторы ресепшн",
  "adminPanel.staff.hint": "Чтобы закрыть доступ уволенному сотруднику, выключите «Может входить».",
  "adminPanel.staff.addDoctor": "Добавить врача",
  "adminPanel.staff.addNurse": "Добавить медсестру",
  "adminPanel.staff.addModerator": "Добавить сотрудника ресепшн",
  "adminPanel.staff.active": "Работает",
  "adminPanel.staff.inactive": "Доступ закрыт",
  "adminPanel.staff.vacation": "В отпуске",
  "adminPanel.staff.canLogin": "Может входить",
  "adminPanel.staff.onVacation": "В отпуске",
  "adminPanel.staff.earnedToday": "Заработал сегодня",
  "adminPanel.clients.hint": "Владельцы питомцев. Пароль можно сменить при редактировании.",
  "adminPanel.clients.add": "Добавить клиента",
  "adminPanel.services.hint": "Прайс-лист услуг и доля врача / медсестры от каждой услуги.",
  "adminPanel.services.add": "Добавить услугу",
  "adminPanel.services.doctorShare": "Доля врача",
  "adminPanel.services.nurseShare": "Доля медсестры",
  "adminPanel.services.sharePercent": "Доля врача, %",
  "adminPanel.services.shareFixed": "Или фикс. сумма врачу",
  "adminPanel.services.shareHint": "Если указан %, используется процент.",
  "adminPanel.services.nursePercent": "Доля медсестры, %",
  "adminPanel.services.rates": "Ставки врачей",
  "adminPanel.services.ratesTitle": "Индивидуальные ставки: {{name}}",
  "adminPanel.services.ratesHint": "По умолчанию врач получает {{share}}. Здесь можно задать другую долю для конкретного врача.",
  "adminPanel.stationary.hint": "Тарифы стационара, которые врач выбирает в медкарте.",
  "adminPanel.stationary.add": "Добавить тариф",
  "adminPanel.stationary.period": "Срок",
  "adminPanel.stationary.amount": "Длительность",
  "adminPanel.stationary.unit": "Единица",
  "adminPanel.stationary.hour": "ч.",
  "adminPanel.stationary.day": "сут.",
  "adminPanel.feeds.hint": "Корма, которые продаёт ресепшн. Остаток в кг уменьшается при продаже.",
  "adminPanel.feeds.add": "Добавить корм",
  "adminPanel.feeds.brand": "Бренд",
  "adminPanel.feeds.product": "Продукт",
  "adminPanel.feeds.factory": "Производитель",
  "adminPanel.feeds.animal": "Животное",
  "adminPanel.feeds.age": "Возраст",
  "adminPanel.feeds.dog": "Собака",
  "adminPanel.feeds.cat": "Кошка",
  "adminPanel.feeds.junior": "Молодой",
  "adminPanel.feeds.adult": "Взрослый",
  "adminPanel.feeds.senior": "Пожилой",
  "adminPanel.feeds.packageKg": "Вес упаковки, кг",
  "adminPanel.feeds.pricePerKg": "Цена за кг",
  "adminPanel.feeds.inStock": "Остаток",
  "adminPanel.feeds.inStockKg": "Остаток, кг",
  "adminPanel.requests.hint": "Заявки, отправленные через форму на сайте.",
  "adminPanel.requests.message": "Сообщение",
  "storage.currency": "сум",
  "storage.form.stepWhat": "Что это за препарат",
  "storage.form.stepPackage": "Упаковка",
  "storage.form.stepPrice": "Цена продажи",
  "storage.form.stepInitial": "Сколько поступило сейчас",
  "storage.form.initialHint": "Необязательно. Если препарат уже на полке — укажите количество, и он сразу появится на складе.",
  "storage.form.stepOther": "Дополнительно",
  "storage.form.initialFailed": "Препарат добавлен, но остаток не сохранён — нажмите «Приход»",

  // Feed sales
  "feedSales.title": "Продажа кормов",
  "feedSales.subtitle": "Продавайте корм любому покупателю — клиенту клиники или человеку с улицы.",
  "feedSales.new": "Новая продажа",
  "feedSales.newTitle": "Продажа корма",
  "feedSales.newHint": "Укажите покупателя, что он берёт, и как платит. Сумма считается автоматически.",
  "feedSales.buyer": "Покупатель",
  "feedSales.mode.walkin": "Покупатель с улицы",
  "feedSales.mode.walkinHint": "Не клиент клиники — нужны только имя и фамилия. Оплата сразу.",
  "feedSales.mode.client": "Клиент клиники",
  "feedSales.mode.clientHint": "Зарегистрированный клиент. Можно оплатить позже.",
  "feedSales.firstName": "Имя",
  "feedSales.lastName": "Фамилия",
  "feedSales.pickClient": "Выберите клиента…",
  "feedSales.searchClient": "Имя или телефон",
  "feedSales.whatBought": "Что купили",
  "feedSales.feed": "Корм",
  "feedSales.pickFeed": "Выберите корм",
  "feedSales.left": "осталось {{kg}}",
  "feedSales.kg": "Количество, кг",
  "feedSales.package": "упаковка {{kg}}",
  "feedSales.addLine": "Добавить ещё корм",
  "feedSales.payment": "Оплата",
  "feedSales.pay.CASH": "Наличные",
  "feedSales.pay.CARD": "Карта",
  "feedSales.pay.TRANSFER": "Перевод",
  "feedSales.pay.LATER": "Оплатит позже",
  "feedSales.total": "Итого",
  "feedSales.sell": "Продать — {{amount}}",
  "feedSales.saveDebt": "Сохранить (в долг)",
  "feedSales.created": "Продажа сохранена",
  "feedSales.paidDone": "Оплачено {{amount}}",
  "feedSales.tabAll": "Все продажи",
  "feedSales.tabUnpaid": "Не оплачено ({{count}})",
  "feedSales.empty": "Продаж пока нет",
  "feedSales.date": "Дата",
  "feedSales.statusLabel": "Статус",
  "feedSales.status.PAID": "Оплачено",
  "feedSales.status.PARTLY_PAID": "Частично",
  "feedSales.status.WAITING": "Не оплачено",
  "feedSales.receive": "Принять оплату",
  "feedSales.payTitle": "Оплата: {{name}}",
  "feedSales.remaining": "Осталось оплатить {{amount}}",
  "feedSales.amount": "Сумма",
  "feedSales.errors.name": "Введите имя покупателя",
  "feedSales.errors.client": "Выберите клиента",
  "feedSales.errors.items": "Добавьте хотя бы один корм и количество",
  "feedSales.errors.fixItems": "Исправьте количество корма",
  "feedSales.errors.pay": "Выберите способ оплаты",
  "feedSales.errors.kg": "Количество должно быть больше нуля",
  "feedSales.errors.stock": "На складе только {{kg}}",
  "feedSales.errors.save": "Не удалось сохранить продажу",
};
